export const getPopup = (state) => {
  return state.popup;
};
